import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import createSelectors from '../utils/createSelectors'

export interface State {
  navOpen: boolean
  headerHidden: boolean
  notificationActive: boolean | null
  bookingModalOpen: boolean
  bookingKey: string
  lenisStop: boolean
  //selectedNavItem: Lib.FragmentOf<typeof MenuDropdownFragment> | null
  currentPath: string
  //tlNav: GSAPTimeline | null
}

/* eslint-disable no-unused-vars */
interface Action {
  setNavOpen: (navOpen: State['navOpen']) => void
  setHeaderHidden: (headerHidden: State['headerHidden']) => void
  setNotificationActive: (
    notificationActive: State['notificationActive']
  ) => void
  setBookingModalOpen: (bookingModalOpen: State['bookingModalOpen']) => void
  setBookingKey: (bookingKey: State['bookingKey']) => void
  //setSelectedNavItem: (selectedNavItem: State['selectedNavItem']) => void
  setCurrentPath: (currentPath: State['currentPath']) => void

  //setTlNav: (tlNav: State['tlNav']) => void
}

const _useStoreNavigation = create<State & Action>()(
  persist(
    (set) => ({
      navOpen: false,
      lenisStop: false,
      //tlNav: null,
      bookingKey: '0',
      headerHidden: false,
      notificationActive: null,
      headerColor: 'dark',
      bookingModalOpen: false,
      //selectedNavItem: null,
      currentPath: '',
      setCurrentPath: (currentPath) => set({ currentPath }),
      setBookingKey: (bookingKey) => set({ bookingKey }),
      setNavOpen: (navOpen) => set({ navOpen: navOpen, lenisStop: navOpen }),
      setNotificationActive: (notificationActive) =>
        set({ notificationActive }),
      setHeaderHidden: (headerHidden) => set({ headerHidden }),
      setBookingModalOpen: (bookingModalOpen) =>
        set({
          bookingModalOpen: bookingModalOpen,
          lenisStop: bookingModalOpen
        })
      //setSelectedNavItem: (selectedNavItem) => set({ selectedNavItem })

      //setTlNav: (tlNav) => set({ tlNav })
    }),
    {
      name: 'navigation',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        notificationActive: state.notificationActive
      })
    }
  )
)

const useStoreNavigation = createSelectors(_useStoreNavigation)

export default useStoreNavigation
